//components
import AppBarLandingPage from "../../components/AppBar/AppBar.landingPage";
import CardPrimary from "../../components/Card/Card.Primary";
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
import ArrowBackIosTwoToneIcon from "@mui/icons-material/ArrowBackIosTwoTone";
import Slider from "react-slick";

import { IconButton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.css";
import config from "../../config/aws-exports";

// import useFetch from "../../Hooks/useFetch";
//slick settings
import { cardSecondarySettings, settings } from "./SlickSettings";

import SignInAndSignUp from "../../components/SignInAndSignUp/SignInAndSignUp";
import { useRef, useState } from "react";
import CardSecondary from "../../components/Card/Card.Secondary";
import CardTopicsSecondary from "../../components/Card/Card.Secondary.Topics";
import { HeadingPrimary } from "../../components/Styles/Heading";
import { CustomButton } from "../../components/CustomButton/CustomButton";
// react router dom
import { useNavigate } from "react-router-dom";

import { useQuery } from "react-query";
// redux
import { useDispatch } from "react-redux";
import { API } from "aws-amplify";
import { session } from "../../redux/Session/Session";
import moment from "moment";
import { sessionAll } from "../../redux/viewAll/viewAll";
// import slide1 from "./slide1.jpg";
// import slide2 from "./slide2.jpg";
// import slide3 from "./slide3.jpg";
const slides = [
  {
    name: "slide1",
    image: `https://${
      config.aws_cloudfront_url
    }/${config.aws_org_id.toLowerCase()}-resources/images/cover-images/slide1.jpg`,
  },
  // {
  //   name: "slide2",
  //   image: `https://${
  //     config.aws_cloudfront_url
  //   }/${config.aws_org_id.toLowerCase()}-resources/images/cover-images/slide2.jpg`,
  //   message: false,
  // },
  // {
  //   name: "slide3",
  //   image: `https://${
  //     config.aws_cloudfront_url
  //   }/${config.aws_org_id.toLowerCase()}-resources/images/cover-images/slide3.jpg`,
  //   message: false,
  // },
  {
    name: "slide4",
    image: `https://${
      config.aws_cloudfront_url
    }/${config.aws_org_id.toLowerCase()}-resources/images/cover-images/slide4.jpg`,
    message: true,
  },
];
export function SampleNextArrow(props) {
  const { onClick } = props;

  return (
    <IconButton
      onClick={onClick}
      // className={className}
      sx={{
        position: "absolute",
        right: "-35px",
        top: "50%",
        transform: "translateY(-30px)",
        zIndex: "800",
        display: { xs: "none", md: "block" },
      }}
    >
      <ArrowForwardIosTwoToneIcon
        // style={{ fontSize: "2.5rem", color: "red" }}
        style={{
          // ...style,
          display: "block",
          // background: "red",
          fontSize: "2.5rem",
        }}
      />
    </IconButton>
    // <div
    //   className={className}
    //   style={{ ...style, display: "block", background: "red" }}
    //   onClick={onClick}
    // />
  );
}

export function SamplePrevArrow(props) {
  const { onClick } = props;

  return (
    <IconButton
      onClick={onClick}
      // className={className}
      sx={{
        position: "absolute",
        left: "-40px",
        top: "50%",
        transform: "translateY(-30px)",
        zIndex: "800",
        display: { xs: "none", md: "block" },
      }}
    >
      <ArrowBackIosTwoToneIcon
        style={{
          // ...style,
          display: "block",
          // background: "red",
          fontSize: "2.5rem",
        }}
      />
    </IconButton>
    // <div
    //   className={className}
    //   style={{ ...style, display: "block", background: "red" }}
    //   onClick={onClick}
    // />
  );
}
const settingsCarousel = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
};

export default function Home() {
  const dispatch = useDispatch();
  const [loginOpen, setLoginOpen] = useState(false);
  const onlySignUp = useRef(false);

  const navigate = useNavigate();

  // Queries
  const { data, isLoading } = useQuery("popularSessionAndCourse", () =>
    API.post(config.aws_cloud_logic_custom_name, "/getWebSessionAndCourse", {
      body: {
        schema: config.schema,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // Authorization: jwttoken,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((err) => console.error(err)),
  );

  const handleLoginClickOpen = (prop) => () => {
    if (prop === "login") {
      setLoginOpen(true);
      onlySignUp.current = false;
    } else {
      setLoginOpen(true);
      onlySignUp.current = true;
    }
  };
  // const settings = {
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 4,
  // };

  // const popularSession = data?.session?.length > 0 && (
  //   <Box sx={{ m: { xs: "1rem", sm: "3rem" } }}>
  //     <HeadingPrimary>Popular Sessions</HeadingPrimary>
  //     <Slider {...settings}>
  //       {data?.session
  //         ?.filter(item => {
  //           // If date_list exists, check combineStartTime
  //           if (item.date_list && item.date_list[0]?.combineStartTime) {
  //             const sessionTime = new Date(item.date_list[0].combineStartTime);
  //             return sessionTime > new Date(); // keep only future sessions
  //           }
  //           // If startdate exists, check that too
  //           if (item.startdate) {
  //             const sessionTime = new Date(parseInt(item.startdate));
  //             return sessionTime > new Date();
  //           }
  //           // If neither exists, keep it (not yet scheduled)
  //           return true;
  //         })
  //         .map((item, idx) => (
  //           <Stack key={idx}>
  //             <CardPrimary
  //               img={
  //                 item.sid &&
  //                 `https://${config.aws_cloudfront_url}/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${item.sid}.png`
  //               }
  //               auth={false}
  //               title={item.sn}
  //               sessionDate={
  //                 item.date_list
  //                   ? moment(new Date(item.date_list[0].combineStartTime)).format("DD MMM YYYY")
  //                   : item.startdate
  //                     ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
  //                     : "yet to be scheduled"
  //               }
  //               handleLocation={() => {
  //                 navigate("/prelogin");
  //                 dispatch(session({ ...item, preLogin: true }));
  //               }}
  //               addToBookMarkList={() => { }}
  //               addToFavorite={() => { }}
  //             />
  //           </Stack>
  //         ))}

  //     </Slider>
  //   </Box>
  // );

  const filteredSessions = data?.session?.filter((item) => {
    // If date_list exists, check combineStartTime
    if (item.date_list?.[0]?.combineStartTime) {
      const sessionTime = new Date(item.date_list[0].combineStartTime);
      return sessionTime > new Date(); // keep only future sessions
    }
    // If startdate exists, check that too
    if (item.startdate) {
      const sessionTime = new Date(parseInt(item.startdate));
      return sessionTime > new Date();
    }
    // If neither exists, keep it (not yet scheduled)
    return true;
  });

  const popularSession = filteredSessions?.length > 0 && (
    <Box sx={{ m: { xs: "1rem", sm: "3rem" } }}>
      <HeadingPrimary>Popular Sessions</HeadingPrimary>
      <Slider {...settings}>
        {filteredSessions
          ?.sort((a, b) => {
            const timeA = a.date_list?.[0]?.combineStartTime
              ? new Date(a.date_list[0].combineStartTime).getTime()
              : a.startdate
                ? parseInt(a.startdate)
                : 0;

            const timeB = b.date_list?.[0]?.combineStartTime
              ? new Date(b.date_list[0].combineStartTime).getTime()
              : b.startdate
                ? parseInt(b.startdate)
                : 0;

            return timeA - timeB;
          })
          .map((item, idx) => (
            <Stack key={idx}>
              <CardPrimary
                img={
                  item.sid &&
                  `https://${config.aws_cloudfront_url}/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${item.sid}.png`
                }
                auth={false}
                title={item.sn}
                sessionDate={
                  item.date_list?.[0]?.combineStartTime
                    ? moment(
                        new Date(item.date_list[0].combineStartTime),
                      ).format("DD MMM YYYY")
                    : item.startdate
                      ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
                      : "yet to be scheduled"
                }
                handleLocation={() => {
                  navigate(`/prelogin?sid=${item?.sid}`);
                  dispatch(session({ ...item, preLogin: true }));
                }}
                addToBookMarkList={() => {}}
                addToFavorite={() => {}}
              />
            </Stack>
          ))}
      </Slider>
    </Box>
  );

  const getSessionDate = (item) => {
    if (item.date_list?.[0]?.combineStartTime) {
      return new Date(item.date_list[0].combineStartTime).getTime();
    }
    if (item.startdate) {
      return parseInt(item.startdate);
    }
    return 0;
  };

  const BiracSession = data?.biracsession?.length > 0 && (
    <Box sx={{ m: { xs: "1rem", sm: "3rem" } }}>
      <HeadingPrimary> DBT – USP – BIRAC Webinar series</HeadingPrimary>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          marginBottom: "1rem",
        }}
      >
        <img
          src={`https://${
            config.aws_cloudfront_url
          }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/ministryofsciencelogo.png`}
          alt="logo"
          height="60"
        />
        <img
          src={`https://${
            config.aws_cloudfront_url
          }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/logo-dark.png`}
          alt="logo"
          height="60"
        />

        <img
          src={`https://${
            config.aws_cloudfront_url
          }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/BIRAC_logo_new.png`}
          alt="logo"
          height="60"
        />
      </div>
      <div>{data?.biractext}</div>
      <Slider {...settings}>
        {data?.biracsession
          ?.sort((a, b) => getSessionDate(a) - getSessionDate(b))
          ?.map((item, idx) => (
            <Stack>
              <CardPrimary
                key={idx}
                img={
                  item.sid &&
                  `https://${
                    config.aws_cloudfront_url
                  }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
                    item.sid
                  }.png`
                }
                auth={false}
                title={item.sn}
                sessionDate={
                  item.date_list
                    ? moment(
                        new Date(item.date_list[0].combineStartTime),
                      ).format("DD MMM YYYY")
                    : item.startdate
                      ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
                      : "yet to be scheduled"
                }
                handleLocation={() => {
                  navigate(`/prelogin?sid=${item?.sid}`);
                  dispatch(session({ ...item, preLogin: true }));
                }}
                addToBookMarkList={() => {}}
                addToFavorite={() => {}}
              />
            </Stack>
          ))}
      </Slider>
    </Box>
  );

  const popularCourse = data?.course?.length > 0 && (
    <Box sx={{ m: { xs: "1rem", sm: "3rem" } }}>
      <HeadingPrimary>Popular Courses</HeadingPrimary>
      <Slider {...cardSecondarySettings}>
        {/* {[...Array(5)].map((item, idx) => ( */}
        {data?.course?.map((item, idx) => (
          <CardSecondary
            key={idx}
            img={
              item?.tid &&
              `https://${
                config.aws_cloudfront_url
              }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                item?.tid
              }.png`
            }
            title={item?.tn}
            sessionDate={moment(parseInt(item?.startdate)).format(
              "DD MMM YYYY",
            )}
            handleLocation={() => {
              navigate(`/preCourse?id=${item?.tid}`);
              dispatch(session({ ...item }));
            }}
            nonug={item?.nugcnt}
          />
        ))}
        {/* ))} */}
      </Slider>
    </Box>
  );

  const allcourse = data?.allcourse?.length > 0 && (
    <Box sx={{ m: { xs: "1rem", sm: "3rem" } }}>
      <HeadingPrimary>Self-paced Courses</HeadingPrimary>
      <Slider {...cardSecondarySettings}>
        {/* {[...Array(5)].map((item, idx) => ( */}
        {data?.allcourse?.map((item, idx) => (
          <CardSecondary
            key={idx}
            img={
              item?.tid &&
              `https://${
                config.aws_cloudfront_url
              }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                item?.tid
              }.png`
            }
            title={item?.ttitle}
            sessionDate={moment(parseInt(item?.startdate)).format(
              "DD MMM YYYY",
            )}
            handleLocation={() => {
              navigate(`/preCourse?id=${item?.tid}`);
              dispatch(session({ ...item }));
            }}
            nonug={item?.nugcnt}
          />
        ))}
        {/* ))} */}
      </Slider>
    </Box>
  );

  const topicsWithCourses =
    data?.topics?.filter((topic) =>
      data?.allcourse?.some(
        (course) => Number(course?.cgry_id) === Number(topic?.id),
      ),
    ) || [];

  const popularTopics = data?.topics?.length > 0 && (
    <Box sx={{ m: { xs: "1rem", sm: "3rem" } }}>
      <HeadingPrimary>Subjects</HeadingPrimary>
      <Slider {...settings}>
        {topicsWithCourses.map((item, idx) => (
          <CardTopicsSecondary
            key={idx}
            img={
              item?.id &&
              `https://${
                config.aws_cloudfront_url
              }/${config.aws_org_id.toLowerCase()}-resources/images/category-images/${
                item?.ct_img
              }`
            }
            title={item?.name}
            handleLocation={() => {
              const filteredCourses = data?.allcourse?.filter(
                (course) => course.cgry_id === item?.id,
              );

              dispatch(
                sessionAll({
                  type: "course",
                  header: item?.name,
                  data: filteredCourses,
                }),
              );
              navigate("/previewall");
            }}
          />
        ))}
        {/* ))} */}
      </Slider>
    </Box>
  );

  return (
    <Box sx={{ pb: 1 }}>
      <AppBarLandingPage handleLoginClick={handleLoginClickOpen} />
      <Slider {...settingsCarousel}>
        {slides.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              backgroundImage: `url('${item.image}')`,
              height: "75vh",
              width: "100vw",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              position: "relative",
              display: "grid",
              placeItems: "top",
            }}
          >
            {item?.message && (
              <div style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "20px",
                    padding: "1.5rem",
                  }}
                >
                  <img
                    src={`https://${
                      config.aws_cloudfront_url
                    }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/ministryofsciencelogo.png`}
                    alt="logo"
                    height="80"
                  />
                  <img
                    src={`https://${
                      config.aws_cloudfront_url
                    }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/logo-dark.png`}
                    alt="logo"
                    height="80"
                  />

                  <img
                    src={`https://${
                      config.aws_cloudfront_url
                    }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/BIRAC_logo_new.png`}
                    alt="logo"
                    height="80"
                  />
                </div>
                <div>
                  <h1
                    style={{
                      fontSize: "3vw",
                      color: "#fff",
                      fontWeight: "700",
                      letterSpacing: "0.3px",
                      lineHeight: "1.2",
                      marginTop: "20px",
                      paddingLeft: "1.5rem",
                    }}
                  >
                    {/* USP-BIRAC <br />
                    COLLABORATION */}
                    DBT – USP – BIRAC Webinar series
                  </h1>

                  <div
                    style={{ color: "white", width: "75%", padding: "1.5rem" }}
                  >
                    The DBT – USP – BIRAC CGT Webinar is envisioned as a
                    high‑level knowledge‑exchange platform tailored to the needs
                    of industry leaders, academic researchers, and translational
                    scientists working in advanced therapies. It brings together
                    biopharmaceutical innovators, start‑ups, manufacturing
                    experts, academic institutions, regulators, and
                    standards‑setting bodies to collectively strengthen India’s
                    readiness across the Cell & Gene Therapy (CGT) value chain.
                    Anchored by the Biotechnology Industry Research Assistance
                    Council (BIRAC) and the United States Pharmacopeia (USP),
                    the webinar series will focus on emerging scientific
                    advancements, evolving regulatory expectations, and quality
                    standards critical for successful CGT development, scale‑up,
                    and commercialization. By fostering dialogue between
                    industry and academia, the program aims to accelerate
                    innovation, support workforce development, and enable the
                    translation of cutting‑edge research into safe,
                    high‑quality, and globally competitive CGT products.
                  </div>
                </div>
              </div>
            )}

            <Stack
              direction="column"
              spacing={8}
              justifyContent="center"
              style={{ minHeight: item?.message ? "unset" : "100%" }}
            >
              {!item?.message ? (
                <h1
                  style={{
                    fontSize: "4vw",
                    color: "#fff",
                    fontWeight: "900",
                    letterSpacing: "1.3px",
                    textAlign: "center",
                  }}
                >
                  Empowering a healthy tomorrow
                </h1>
              ) : null}
              <Stack direction="row" spacing={5} justifyContent="center">
                <CustomButton onClick={handleLoginClickOpen("login")} primary>
                  Login
                </CustomButton>
                <CustomButton onClick={handleLoginClickOpen("signUp")} primary>
                  Sign up
                </CustomButton>
              </Stack>
            </Stack>
          </Box>
        ))}
      </Slider>

      {!isLoading && popularSession}
      {!isLoading && BiracSession}
      {!isLoading && popularCourse}
      {!isLoading && allcourse}
      {!isLoading && popularTopics}
      {loginOpen && (
        <SignInAndSignUp
          loginOpen={loginOpen}
          setLoginOpen={setLoginOpen}
          onlySingUp={onlySignUp}
        />
      )}
    </Box>
  );
}
